module.exports = __webpack_public_path__ + "img/1.1faf1232.png";